export default {
  main: "Primair e-mailadres",
  invoice: "Facturatie e-mailadres",
}
